import { ContextMenuViewport } from '@ohif/ui-next';

export default {
  'ui.contextMenu': ContextMenuViewport,
};
